import React from 'react';
import { useNavigate } from 'react-router-dom';
import Ornament from './components/Ornament';
import Icon from './components/Icon';
import './Refer.css';   // re-using the Refer landing styles

const Collaborate = () => {
    const navigate = useNavigate();

    return (
        <div className="refer-page">

            <section className="refer-hero sw-aurora">
                <div className="refer-hero-inner">
                    <Ornament variant="rule" tone="gold" size={140} />
                    <span className="refer-eyebrow">Collaborate · Verify · Open Up</span>
                    <h1>Bring your institution onto Samudyoga</h1>
                    <p className="refer-lead">
                        Temples, maṭhas, pāṭhaśālās, universities, NGOs, businesses, family
                        offices — Samudyoga lets verified collaborators post in-house openings,
                        keep them internal to their members, or open them up to the wider Dharmik
                        network. The choice is yours per posting.
                    </p>
                    <div className="refer-cta-row">
                        <button className="sw-btn sw-btn-saffron" onClick={() => navigate('/enroll/collaborator')}>
                            <span>Become a Collaborator</span>
                            <Icon name="arrow" size={14} />
                        </button>
                    </div>
                </div>
            </section>

            <section className="refer-section">
                <div className="sw-section-mark">What collaboration looks like</div>
                <div className="refer-grid">
                    <div className="refer-card">
                        <div className="refer-card-icon">1</div>
                        <h3>Register your organisation</h3>
                        <p>One profile per institution; multiple branches supported. Tax/registration ID + a primary contact.</p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">2</div>
                        <h3>Get verified</h3>
                        <p>Platform team reviews documents; verified badge unlocks posting and member invitations.</p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">3</div>
                        <h3>Post openings</h3>
                        <p>Internal-only by default — visible to your members. Toggle <em>Public</em> per posting to reach the network.</p>
                    </div>
                    <div className="refer-card">
                        <div className="refer-card-icon">4</div>
                        <h3>Decide who applies</h3>
                        <p>Accept internal, external, or both. Manage applications inside your collaborator dashboard.</p>
                    </div>
                </div>
            </section>

            <section className="refer-section">
                <div className="sw-section-mark">Who collaborates</div>
                <div className="refer-grid">
                    <div className="refer-card">
                        <h3>Temples &amp; Maṭhas</h3>
                        <p>Archakas, ṛtviks, administrative roles, seva volunteers — internal-first, opened externally when needed.</p>
                    </div>
                    <div className="refer-card">
                        <h3>Pāṭhaśālās &amp; Universities</h3>
                        <p>Faculty, research, residency, admissions for students. Teaching positions across regions.</p>
                    </div>
                    <div className="refer-card">
                        <h3>Trusts &amp; NGOs</h3>
                        <p>Programme managers, fundraising, administrative leads. Volunteer matching for major events.</p>
                    </div>
                    <div className="refer-card">
                        <h3>Dharmik Businesses</h3>
                        <p>Publishing, heritage services, wellness, artisan enterprises — short-term to long-term hires.</p>
                    </div>
                    <div className="refer-card">
                        <h3>Family Offices</h3>
                        <p>Personal services for events, household roles, traditional preparation work.</p>
                    </div>
                    <div className="refer-card">
                        <h3>Multi-branch Umbrellas</h3>
                        <p>Networks with 100+ branches (e.g., ISKCON, SGS Āśrama scale) coordinate hiring centrally; branch-admins manage locally.</p>
                    </div>
                </div>
            </section>

            <section className="refer-section">
                <div className="sw-section-mark">Ready when you are</div>
                <div className="refer-roadmap">
                    <p>
                        The collaborator enrollment form below captures everything we need to
                        verify and onboard your institution. After submission, our team reviews
                        documents (typically 2–3 working days) and activates posting privileges.
                    </p>
                    <div style={{ marginTop: 18, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                        <button className="sw-btn sw-btn-saffron" onClick={() => navigate('/enroll/collaborator')}>
                            <span>Enrol as a Collaborator</span>
                            <Icon name="arrow" size={14} />
                        </button>
                        <button className="sw-btn sw-btn-ghost" onClick={() => navigate('/contact-us')}>
                            <span>Talk to us first</span>
                        </button>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Collaborate;
